import React, { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Current_User, Recoil_Quarter_State, System_Date_Time_State } from '../../../recoil/recoil';
import AlertBanner from '../../atoms/alerts/alertBanner';
import { getAlertBarDetails } from '../../../util/commonFunctions';

const DashboardAlerts = props => {
  let screenName = props.screenName;
  const [quarterData, setQuarterData] = useRecoilState(Recoil_Quarter_State);
  const [forecastStatus, setForecastStatus] = useState({});
  const [alertBarInfo, setAlertBarInfo] = useState({});
  const currentUser = useRecoilValue(Current_User);
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  let alertStatusDetails = null;

  const fetchForecastSubmitStatus = async () => {
    if (!quarterData) {
      return;
    }
    let apiPayload = {
      email: currentUser.email,
      role: currentUser.role,
      month: quarterData.month.toLowerCase(),
      year: quarterData.fiscal_year,
      accountId: currentUser.account_id,
    };

    try {
      alertStatusDetails = await getAlertBarDetails(
        quarterData,
        apiPayload,
        screenName,
        systemDateTime,
      );
      setAlertBarInfo(alertStatusDetails);
    } catch (error) {
      console.error('Error fetching forecast submit status:', error);
    }
  };

  useEffect(() => {
    fetchForecastSubmitStatus();
  }, [quarterData]);

  return (
    <AlertBanner
      title={alertBarInfo?.title}
      description={alertBarInfo?.description}
      type={alertBarInfo?.type}
      showButton={alertBarInfo?.showButton}
    />
  );
};

export default DashboardAlerts;
